{
  "version": 1,
  "asset_id": "bdd52d29-99fb-4a22-af51-7f0647e7d04c",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/bdd52d29-99fb-4a22-af51-7f0647e7d04c/tonight-parallax-bg.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/bdd52d29-99fb-4a22-af51-7f0647e7d04c/tonight-parallax-bg.webp",
  "original_filename": "tonight-parallax-bg.webp",
  "size": 388616,
  "content_type": "image/webp",
  "created_at": "2026-07-04T16:13:13Z"
}
